import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  constructor() {
    super();
    this.cartMenu = null;
    this.isMenuOpen = false;
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.cartMenu = this.querySelector('[ref="cartMenu"]');
    document.addEventListener('click', this.#handleOutsideClick.bind(this));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.removeEventListener('click', this.#handleOutsideClick.bind(this));
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    if (this.cartMenu) {
      this.cartMenu.classList.toggle('cart-menu-drawer--open', this.isMenuOpen);
    }
  }

  openCart() {
    this.#closeMenu();
    this.open();
  }

  openGinCart() {
    this.#closeMenu();
    const liquidCartIcon = document.getElementById("liquidCartIcon");
    if (liquidCartIcon) {
      liquidCartIcon.click();
    }
  }

  #closeMenu() {
    this.isMenuOpen = false;
    if (this.cartMenu) {
      this.cartMenu.classList.remove('cart-menu-drawer--open');
    }
  }

  #handleOutsideClick(event) {
    if (!this.contains(event.target) && this.isMenuOpen) {
      this.#closeMenu();
    }
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
